// extracted by mini-css-extract-plugin
export default {"list":"ListView_list__2Qe9A"};